import { render, staticRenderFns } from "./Athletes.vue?vue&type=template&id=dbf45972&scoped=true&"
import script from "./Athletes.vue?vue&type=script&lang=js&"
export * from "./Athletes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf45972",
  null
  
)

export default component.exports